'use client';
import { css } from 'styled-system/css';

export const topMenuStyle = {
	tip: css({
		position: 'fixed',
		zIndex: 25,
		top: '87px',
		left: '14px',
		display: 'block',
		backgroundColor: 'var(--background-status-hint, var(--special-19))',
		color: 'var(--text-utility-matching-white-100-black-80, var(--lv2-80))',
		md: {
			display: 'none',
		}
	}),
};